import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter as Router} from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import store from './redux/store';
import { Provider } from 'react-redux';
import { ToastProvider } from './redux/provider/toastprovider';
import AuthProvider from './redux/provider/authprovider';




const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
  // <React.StrictMode>    
    <Provider store={store}>            
      
      <Router>       
      <AuthProvider>  
          <ToastProvider>
            <App />     
          </ToastProvider>  
          </AuthProvider>      
      </Router>          
      
    </Provider>    
  //  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
